module.exports = __webpack_public_path__ + "img/form1.6758f16d.png";